import { salesHttp } from "@salesdi";
import action from "./action";
import presenters from "./presenters";
import repositories from "./repositories";
import useCases from "../di/useCases";
var cRepositories = repositories(salesHttp);
var cUseCases = useCases(cRepositories);
var cActions = action();
var cPresenters = presenters(cActions, cUseCases);
export default {
    clients: cPresenters.clients,
    partnerOverview: cPresenters.partnerOverview,
};
